module.exports = __webpack_public_path__ + "img/PantallaPromo-01.svg.0a257393.webp";